import { Box } from '@mui/material';
import styled from 'styled-components';

export const JobLogsContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  position: relative;

  .monaco-editor .job-log-line-info {
    color: ${({ theme }) => `${theme.palette.status.grey.text} !important`};
  }

  .monaco-editor .job-log-line-warning {
    color: ${({ theme }) => `${theme.palette.status.orange.text} !important`};
  }

  .monaco-editor .job-log-line-error {
    color: ${({ theme }) => `${theme.palette.status.red.text} !important`};
  }
`;

export const JobLogsFilterContainer = styled(Box)`
  && {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    gap: 0.75rem;
    margin-bottom: 1rem;
    margin-right: 1rem;
  }
`;

export const JobLogsEditorContainer = styled(Box)`
  && {
    flex: 1;
    min-height: 0;
    padding-bottom: 1.5rem;
  }
`;

export const JobLogsLoadingContainer = styled(Box)`
  && {
    position: absolute;
    left: 4.25rem;
    bottom: 0.25rem;
    display: flex;
    align-items: center;
    pointer-events: none;
  }
`;
